import { indexData, mediaData } from '@/mocks/homeData';

export default function IndexMediaSection() {
  return (
    <>
      <section id="index" className="py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">爆料合集</h2>
            <p className="mt-2 text-sm text-foreground-500">分类索引 · 一站吃遍</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
            {indexData.map((item, idx) => (
              <div
                key={idx}
                className="flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-xl cursor-pointer hover:-translate-y-0.5 transition-all duration-300 border border-background-200 hover:border-primary-200"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap truncate">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1">{item.count} 篇内容</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="media" className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">现场直击</h2>
            <p className="mt-2 text-sm text-foreground-500">精彩内容 · 视觉吃瓜</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {mediaData.map((item, idx) => (
              <div key={idx} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 cursor-pointer transition-all duration-300 hover:-translate-y-1">
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-600/90 text-background-50 group-hover:bg-primary-700 transition-colors">
                      <i className="ri-play-fill text-2xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-3 right-3 px-2 py-1 rounded bg-black/70 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.duration}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2">{item.title}</h3>
                  <p className="mt-2 text-xs text-foreground-500">{item.views} 次播放</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}